/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Short_Rod_StrokeInputs */



/**
* | output |
* | --- |
* | "Short rod stroke" |
*
* @param {Short_Rod_StrokeInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const short_rod_stroke = /** @type {((inputs?: Short_Rod_StrokeInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Short_Rod_StrokeInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Short rod stroke")
	return /** @type {LocalizedString} */ ("Course de la tige faible")
});